import React from "react";
import {
    FaCarSide,
    FaShieldAlt,
    FaClock,
    FaHeadset,
} from "react-icons/fa";
import { RiArrowRightLine } from "react-icons/ri";

const AboutRentQ = () => {
    return (
<div className="about-rentq p-0 py-3">
            <div
                className="container"
                data-cues="slideInUp"
                data-group="aboutUsContent"
            >
                <div className="mb-[30px] md:mb-[35px] lg:mb-[40px]">
                    <span className="block font-bold  textg ">
                        About Sai Shirdi Cab
                    </span>

                    <h2 className="mb-0 text-xl md:text-2xl lg:text-3xl leading-[1.2]">
                        At Sai Shirdi Cab, we are committed to making your
                        journey safe, comfortable, and hassle-free. Whether
                        you are visiting Shirdi for a pilgrimage, travelling
                        with family, or planning an outstation trip, we provide
                        reliable cab services with experienced drivers and
                        well-maintained vehicles.
                    </h2>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-[25px] items-center">
                    <div>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-[20px] lg:gap-[25px] xl:gap-[35px]">

                            {/* Safety First */}
                            <div className="group">
                                <div className="leading-none text-5xl mb-[10px] md:mb-[15px] lg:mb-[18px] transition-all ease-in-out duration-300 group-hover:text-primary">
                                    <FaShieldAlt />
                                </div>

                                <h3 className="text-base md:text-lg lg:text-xl leading-[1.2] mb-[10px] md:mb-[12px]">
                                    Safe & Reliable
                                </h3>

                                <p>
                                    Your safety is our priority. Our experienced
                                    drivers provide a secure and comfortable
                                    journey for every passenger.
                                </p>
                            </div>

                            {/* Premium Quality */}
                            <div className="group">
                                <div className="leading-none text-5xl mb-[10px] md:mb-[15px] lg:mb-[18px] transition-all ease-in-out duration-300 group-hover:text-primary">
                                    <FaCarSide />
                                </div>

                                <h3 className="text-base md:text-lg lg:text-xl leading-[1.2] mb-[10px] md:mb-[12px]">
                                    Well-Maintained Cabs
                                </h3>

                                <p>
                                    Our clean and well-maintained vehicles are
                                    designed to provide you with a smooth and
                                    comfortable ride.
                                </p>
                            </div>

                            {/* Punctuality */}
                            <div className="group">
                                <div className="leading-none text-5xl mb-[10px] md:mb-[15px] lg:mb-[18px] transition-all ease-in-out duration-300 group-hover:text-primary">
                                    <FaClock />
                                </div>

                                <h3 className="text-base md:text-lg lg:text-xl leading-[1.2] mb-[10px] md:mb-[12px]">
                                    On-Time Pickup
                                </h3>

                                <p>
                                    We value your time and provide timely pickup
                                    and drop-off services for a stress-free
                                    travel experience.
                                </p>
                            </div>

                            {/* 24/7 Support */}
                            <div className="group">
                                <div className="leading-none text-5xl mb-[10px] md:mb-[15px] lg:mb-[18px] transition-all ease-in-out duration-300 group-hover:text-primary">
                                    <FaHeadset />
                                </div>

                                <h3 className="text-base md:text-lg lg:text-xl leading-[1.2] mb-[10px] md:mb-[12px]">
                                    24/7 Support
                                </h3>

                                <p>
                                    Our support team is always available to
                                    assist you with bookings and travel
                                    requirements.
                                </p>
                            </div>

                        </div>

                        <a
                            href="about-us"
                            className="primary-btn group mt-[20px] md:mt-[25px] lg:mt-[30px]"
                        >
                            <span>
                                More About Us
                            </span>

                            <RiArrowRightLine />
                        </a>
                    </div>

                    <div className="text-center rounded-[15px]">
                        <img
                            src="/images/abouttt.png"
                            className="rounded-[15px]"
                            alt="Sai Shirdi Cab"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutRentQ;
